import React, {FC, Fragment} from 'react';
import './style.scss';
import {pathSuite} from "../../../constants";
import {useHistory} from "react-router-dom";
import PopularMixes from "../PopularMixes";
import Compilations from "../Collections";
import {ICompilation, IMix} from "../../../constants/types";

interface IRecommendations {
    mixWeek: IMix,
    popularMixes: Array<IMix>,
    setTobaccoIndex: any,
    ourCompilations:Array<ICompilation>,
    hookahCompilations: Array<ICompilation>,
    authorCompilations: Array<ICompilation>,
    setIndexCompilations: any,
    fetchMixCompilation: any
    setCurrentCompilations: any
}


const Recommendations: FC<IRecommendations> = ({
                                                   mixWeek,
                                                   popularMixes,
                                                   setTobaccoIndex,
                                                   ourCompilations,
                                                   hookahCompilations,
                                                   authorCompilations,
                                                   setIndexCompilations,
                                                   fetchMixCompilation,
                                                   setCurrentCompilations

                                               }) => {
    const history = useHistory();
    return (
        <Fragment>
            <div className="recommend">
                <div className="recommend__container">
                    <div className="recommend__mix-week">
                        <div className="mix-week__subtitle">
                            Новинка
                        </div>
                        <div className="mix-week__title">
                            Вкус недели
                        </div>
                        <div className="mix-week__card"
                             onClick={() => history.push('/main/mix-week')}>
                            <div className="mix-week__name">
                                {mixWeek.name}
                            </div>
                            <div className="mix-week__image">
                                <img className='mix-week__img'
                                     src={pathSuite + mixWeek.imageUrl}
                                     alt="Фото микса"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="recommend__popular-mixes">
                        <PopularMixes
                            popularMixes={popularMixes}
                            setTobaccoIndex={setTobaccoIndex}
                        />
                    </div>
                    <div className="recommend__collections">
                        <Compilations
                            ourCompilations={ourCompilations}
                            hookahCompilations={hookahCompilations}
                            authorCompilations={authorCompilations}
                            setIndexCompilations={setIndexCompilations}
                            fetchMixCompilation={fetchMixCompilation}
                            setCurrentCompilations={setCurrentCompilations}
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    )
};

export default Recommendations;
